import { create } from 'zustand';
import type { User } from '../types';
import type { PermissionDetail } from '../lib/api';
import * as api from '../lib/api';

interface AuthState {
  currentUser: User | null;
  permissions: PermissionDetail[] | null;
  guildId: string | null;
  initialized: boolean;

  setCurrentUser: (user: User | null) => void;
  setPermissions: (permissions: PermissionDetail[] | null) => void;
  setGuildId: (guildId: string | null) => void;
  setInitialized: () => void;
  reset: () => void;

  loadCurrentUser: () => Promise<void>;
  loadPermissions: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()((set) => ({
  currentUser: null,
  permissions: null,
  guildId: null,
  initialized: false,

  setCurrentUser: (user) => set({ currentUser: user }),
  setPermissions: (permissions) => set({ permissions }),
  setGuildId: (guildId) => set({ guildId }),
  setInitialized: () => set({ initialized: true }),

  loadCurrentUser: async () => {
    try {
      const user = await api.fetchMe();
      set({ currentUser: user });
    } catch {
      // Not authenticated
    }
  },

  loadPermissions: async () => {
    try {
      const data = await api.fetchMyPermissions();
      set({ permissions: data.details });
    } catch {
      // Ignore
    }
  },

  reset: () => set({ currentUser: null, permissions: null, guildId: null, initialized: false }),
}));
